import React from 'react';
import {
  ShieldCheck,
  Award,
  Brush,
  Calendar,
  Heart,
  Star,
} from 'lucide-react';
import { features } from '../mock';

const iconMap = { ShieldCheck, Award, Brush, Calendar, Heart, Star };

const WhyChooseUs = () => {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="inline-flex items-center gap-2 bg-pink-50 border border-pink-200 text-pink-600 rounded-full px-3 py-1 text-xs font-semibold tracking-wider mb-4">
            THE DIFFERENCE
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-gray-900">
            Why Choose <span className="gradient-text">S Pink Nails</span>
          </h2>
          <p className="mt-4 text-gray-600 text-lg">
            Experience the difference of professional care
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f) => {
            const Icon = iconMap[f.icon] || Star;
            return (
              <div
                key={f.id}
                className="group relative rounded-2xl p-7 border border-pink-100 bg-gradient-to-br from-white to-pink-50/50 hover:from-pink-50 hover:to-rose-50 transition-all duration-300"
              >
                <div className="w-12 h-12 rounded-xl bg-white shadow-md border border-pink-100 flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300">
                  <Icon className="h-5 w-5 text-pink-600" />
                </div>
                <h3 className="font-display text-xl font-semibold text-gray-900 mb-2">
                  {f.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">{f.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
